<app-header [label]="page_name"></app-header>

<div class="flex items-center justify-between p-4 border-b border-gray-300 bg-white">
  <button (click)="gs.go_back()" class="flex items-center gap-1 text-sm text-gray-700 hover:text-black">
    <i class="bx bx-arrow-back text-lg"></i> Back
  </button>
  <!-- <span *ngIf="level" class="text-sm font-semibold text-gray-600">Published Level: {{ level === 'HE' ? 'Head Evaluation' : level === 'AI' ? 'AI Score' : ('Level ' + level) }}</span> -->
  <button *ngIf="pages.length" [disabled]="is_paginating" (click)="download_script()" class="flex items-center gap-1 text-sm text-[#3F41D1] hover:text-[#2f31a8] disabled:opacity-50 disabled:cursor-not-allowed">
    <i class="bx bx-download text-lg"></i> {{ is_paginating ? 'Preparing...' : 'Download' }}
  </button>
</div>

<div class="w-full h-[calc(100vh-100px)] overflow-auto bg-gray-200 flex flex-col items-center py-6" *ngIf="!is_loading">

  <div id="printable-script" class="paper-wrapper relative mx-auto w-[480px] flex flex-col gap-2 items-center">
    <div *ngFor="let page of pages; let i = index" class="script-page relative w-full">
      <img [id]="'script-page-img-' + i" (load)="on_page_image_loaded(i)" [src]="'https://novamark-uat-api.hubblehox.ai' + '/media/get-file?file_path=scripts/' + page.image" draggable="false" class="w-full object-contain rounded-lg bg-white select-none shadow" />

      <div *ngFor="let item of page.annotations" class="absolute flex items-center justify-center text-center select-none" [style.left.px]="item.x" [style.top.px]="item.y">
        <div class="relative">
          <i *ngIf="!item.img" [ngClass]="{ 'text-indigo-700': item.icon === 'bx bx-chat', 'text-green-600': item.icon === 'bx bx-check', 'text-[#E5383B]': item.icon === 'bx bx-x'}" class="{{ item.icon }} text-5xl mt-3"></i>
          <img *ngIf="item.img" [src]="item.img" [ngClass]="{'min-w-[400px] max-w-[400px]': item.icon !== 'drawing'}" class="h-full object-contain" />
        </div>

        <div *ngIf="item.icon === 'bx bx-check' || item.icon === 'bx bx-x'" class="mt-2 flex flex-nowrap items-center gap-2 bg-white shadow px-2 py-1 rounded text-sm">
          <span class="px-1" *ngIf="item.question_number">Q{{ item.question_number }}</span>
          <span class="w-[1px] h-4 bg-gray-500 rounded-full"></span>
          <span class="px-1" *ngIf="item.given_mark !== null && item.given_mark !== undefined">{{ item.given_mark }}</span>
        </div>

        <div *ngIf="item.icon === 'bx bx-chat'" class="mt-2 min-w-[200px] bg-white shadow-md p-2 rounded-lg text-sm text-gray-700">
          {{ item.message }}
        </div>
      </div>
    </div>

    <div *ngIf="question_marks.length && !is_paginating" class="script-page relative w-full bg-white rounded-lg shadow p-4">
      <!-- <h3 class="text-base font-semibold text-gray-800 mb-3 text-center">Question-wise Marks</h3> -->
      <table class="w-full text-sm border border-gray-300">
        <thead>
          <tr class="bg-gray-100">
            <th class="border border-gray-300 px-2 py-1 text-left">Question No.</th>
            <th class="border border-gray-300 px-2 py-1 text-left">Obtained Marks</th>
            <th class="border border-gray-300 px-2 py-1 text-left">Max Marks</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let q of question_marks">
            <td class="border border-gray-300 px-2 py-1">{{ q.question_number }}</td>
            <td class="border border-gray-300 px-2 py-1">{{ q.obtained }}</td>
            <td class="border border-gray-300 px-2 py-1">{{ q.max }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="!pages.length && !is_ai_scored" class="text-gray-500 text-sm mt-8">No script pages available.</div>
</div>

<div class="w-full min-h-[60vh] flex items-center justify-center" *ngIf="is_loading">
  <span class="text-gray-500 text-sm">Loading script...</span>
</div>